import React from "react";

interface InfoFieldProps {
  label: string;
  value: string | null | undefined;
}

/**
 * InfoField
 * Displays a label and value pair for read-only information display.
 * Used in forms and detail views to show structured information.
 */
export const InfoField: React.FC<InfoFieldProps> = ({ label, value }) => (
  <div>
    <label className="text-sm font-medium text-gray-500">{label}</label>
    <p className="text-base text-gray-900 mt-1">{value || "N/A"}</p>
  </div>
);

